import React, { useEffect, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import {
  Title,
  SubTitle,
  UnderlineText,
  Text,
  LeftSide,
  Column,
  Row,
  InputContainer,
  Inputs,
  ButtonContainer,
  Icon,
  Row2,
  StyledInput,
} from './LoginPage.styles';
import Button from '../../../components/utils/Button/Button';
import { ReactComponent as Logo } from '../../../assets/icons/logoBlack.svg';
import { useNavigate } from 'react-router-dom';
import MainContainer from '../../../components/MainContainer/MainContainer';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../../../store/slice/auth/asyncThunks';
import { fetchVendorInfo } from '../../../store/slice/vendor/asyncThunks';
import { selectLoggedPending } from '../../../store/slice/auth/slice';
import { notifyError } from '../../../utils/notify';
import ReactGA from 'react-ga';

const LoginPage = () => {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [visibility, setVisibility] = useState(true);
  const pending = useSelector(selectLoggedPending);

  const handleEmailChange = e => {
    const newEmail = e.target.value;
    setEmail(newEmail);
  };

  const handlePasswordChange = e => {
    const newPassword = e.target.value;
    setPassword(newPassword);
  };

  const handleVisibilityChange = () => {
    setVisibility(!visibility);
  };

  const onLogin = () => {
    ReactGA.event({ category: 'Login', action: 'Login', label: 'Login/' + email });

    dispatch(login({ email, password }))
      .unwrap()
      .then(() => {
        dispatch(fetchVendorInfo())
          .unwrap()
          .then(data => {
            if (!data.name) {
              navigation({
                pathname: '/sign-up',
                search: `?step=1`,
              });
            } else {
              navigation({
                pathname: '/clients',
              });
            }
          });
      })
      .catch(err => {
        console.log(err.message);
        notifyError(err.message);
      });
  };

  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      onLogin();
    }
  };

  useEffect(() => {
    document.addEventListener('keypress', handleKeyPress);

    return () => {
      document.removeEventListener('keypress', handleKeyPress);
    };
  }, [handleKeyPress]);

  return (
    <MainContainer>
      <LeftSide>
        <Logo width={110} height={58} />
        <Column>
          <Title>Welcome back!</Title>
          <SubTitle>Log in to your account.</SubTitle>
        </Column>
        <InputContainer>
          <Inputs>
            <StyledInput placeholder="Email Address" value={email} onChange={handleEmailChange} />
            <StyledInput
              placeholder="Password"
              value={password}
              onChange={handlePasswordChange}
              type={visibility ? 'password' : 'text'}
              rightIcon={
                visibility ? (
                  <Icon onClick={handleVisibilityChange}>🙈</Icon>
                ) : (
                  <Icon onClick={handleVisibilityChange}>🐵</Icon>
                )
              }
            />
          </Inputs>
          <Row2>
            {/* {error && <Text>{error}</Text>} */}
            <UnderlineText $direction={true} onClick={() => navigation('/forgot-password')}>
              Forgot Password?
            </UnderlineText>
          </Row2>
        </InputContainer>
        <ButtonContainer>
          <Button onClick={onLogin} title={'Continue'} width disabled={pending} loading={pending} />

          <Row>
            <Text>Don’t have an account?</Text>
            <UnderlineText
              onClick={() =>
                navigation({
                  pathname: '/sign-up',
                  search: `?step=0`,
                })
              }>
              Register Now
            </UnderlineText>
          </Row>
        </ButtonContainer>
      </LeftSide>
    </MainContainer>
  );
};

export default LoginPage;
